export default {
  text: '#343332',
  primary: '#202020',
  secondary: '#831215',
  background: 'white',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
